import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class PromotionService {
  /**
   * Fetch promotions with server-side pagination.
   * The backend returns:
   * {
   *   status: true,
   *   message: "...",
   *   data: {
   *     promotions: [...],
   *     pagination: { total, page, limit, totalPages }
   *   }
   * }
   */
  fetchPromotions = (
    page = 1,
    limit = 10,
    search = '',
    typeFilter = '',
    activeStatus = null,
    startDate = null,
    endDate = null,
    promotionId = '',
  ) => {
    let url = `${BASE_URL}/v1/promotions/?page=${page}&limit=${limit}`;

    if (search && String(search).trim()) {
      url += `&promocode=${encodeURIComponent(String(search).trim())}`;
    }

    if (typeFilter && typeFilter !== 'All Types') {
      url += `&type=${encodeURIComponent(typeFilter)}`;
    }

    if (activeStatus !== null) {
      url += `&active=${activeStatus}`;
    }

    if (startDate) {
      const formattedStartDate =
        startDate instanceof Date
          ? startDate.toISOString().split('T')[0]
          : startDate.format
            ? startDate.format('YYYY-MM-DD')
            : startDate;
      url += `&start_date=${formattedStartDate}`;
    }

    if (endDate) {
      const formattedEndDate =
        endDate instanceof Date
          ? endDate.toISOString().split('T')[0]
          : endDate.format
            ? endDate.format('YYYY-MM-DD')
            : endDate;
      url += `&end_date=${formattedEndDate}`;
    }

    return axiosInstance.get(url);
  };
  createNewPromotion = (promotionData, isMultipart) => {
    // If promotionData is FormData, let browser set Content-Type with boundary
    // Otherwise, set multipart/form-data header
    const config =
      promotionData instanceof FormData
        ? {}
        : { headers: { 'Content-Type': 'multipart/form-data' } };
    return axiosInstance.post(
      `${BASE_URL}/v1/promotions/`,
      promotionData,
      config,
    );
  };
  addPromotion = (promotionData) => {
    return axiosInstance.post(`${BASE_URL}/v1/promotions/`, promotionData);
  };

  updatePromotion = (id, promotionData) => {
    // If promotionData is FormData, let browser set Content-Type with boundary
    // Otherwise, set multipart/form-data header
    const config =
      promotionData instanceof FormData
        ? {}
        : { headers: { 'Content-Type': 'multipart/form-data' } };

    return axiosInstance.put(
      `${BASE_URL}/v1/promotions/${String(id)}`,
      promotionData,
      config,
    );
  };
  deletePromotion = (id) => {
    return axiosInstance.delete(`${BASE_URL}/v1/promotions/${String(id)}`);
  };
  applyPromotionToUsers = (id, params) => {
    return axiosInstance.post(`${BASE_URL}/v1/promotions/${id}/apply`, params);
  };
  softDeletePromotion = (id) => {
    return axiosInstance.delete(
      `${BASE_URL}/v1/promotions/soft-delete/${String(id)}`,
    );
  };
  getPromotionById = (id) => {
    return axiosInstance.get(`${BASE_URL}/v1/promotions/${String(id)}`);
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PromotionService();
